import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

const HypeInput = z.object({
  match_id: z.string().min(1).max(64),
  session_id: z.string().min(1).max(64),
  pulse_type: z.enum(["fire", "wow", "var", "goal"]).default("fire"),
  pulse_count: z.number().int().min(1).max(50),
});

export const submitHypePulse = createServerFn({ method: "POST" })
  .inputValidator((input) => HypeInput.parse(input))
  .handler(async ({ data }) => {
    const bucket = Math.floor(Date.now() / 1000);
    const { error } = await supabaseAdmin.from("hype_pulses").insert({
      match_id: data.match_id,
      session_id: data.session_id,
      pulse_type: data.pulse_type,
      pulse_count: data.pulse_count,
      bucket_sec: bucket,
    });
    if (error) return { ok: false, error: error.message };
    return { ok: true, bucket };
  });